import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const NotificationIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
    {...props}
  >
    <Path d="M6.55 14.0833V14.75C6.55 15.8546 7.42304 16.75 8.5 16.75C9.57695 16.75 10.45 15.8546 10.45 14.75V14.0833M15 14.0833V7.25C15 3.66015 12.0899 0.75 8.5 0.75C4.91015 0.75 2 3.66015 2 7.25V14.0833H15Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

NotificationIcon.displayName = 'NotificationIcon';
